export const SCREEN_SIZE = {
    mobilesUp: 768,
    tabletsUp: 1024,
    mobileSteper: 1250
};

export const CONTAINER_SIZE = {
    desktops : 792,
    tablets: 588,
    mobiles: 372,
}

